import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SAR_URL } from '../../utils/contact';
import './SarImport.scss';

const SarImport = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // 외부 서비스 URL을 Nginx 프록시 경로로 설정
  const externalServiceUrl = SAR_URL;
  // const externalServiceUrl = '/sar-service';
  console.log("externalServiceUrl["+externalServiceUrl+"]");
  
  useEffect(() => {
    const handleIframeLoad = () => {
      setLoading(false);
    };
    
    const handleIframeError = () => {
      setLoading(false);
      setError('외부 서비스를 불러오는 데 실패했습니다.');
    };
    
    const iframe = document.getElementById('sar-service-iframe');
    if (iframe) {
      iframe.addEventListener('load', handleIframeLoad);
      iframe.addEventListener('error', handleIframeError);
    }
    
    return () => {
      if (iframe) {
        iframe.removeEventListener('load', handleIframeLoad);
        iframe.removeEventListener('error', handleIframeError);
      }
    };
  }, []);

  return (
    <div className="sar-import-container">
      <div className="page-title p-16">{t('pageTitle.generator')}</div>
      
      <>
        {loading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
            <p>외부 서비스를 불러오는 중입니다...</p>
          </div>
        )}
        
        {error && (
          <div className="error-message">
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>다시 시도</button>
          </div>
        )}
        
        <div className="iframe-container">
          <iframe
            id="sar-service-iframe"
            src={externalServiceUrl}
            title="Generator"
            width="100%"
            height="100%"
            frameBorder="0"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
          ></iframe>
        </div>
      </>
      
      <div className="download-info">
        <p>다운로드 기능이 작동하지 않는 경우, <a href={externalServiceUrl} target="_blank" rel="noopener noreferrer">여기</a>를 클릭하여 새 탭에서 서비스를 열어주세요.</p>
      </div>
    </div>
  );
};

export default SarImport;
